import * as React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { UserConsumer } from 'client/components/UserContext';

import LoadingIndicator from './LoadingIndicator';

const PrivateRoute = (props: RouteProps) => (
  <UserConsumer>
    {({ userId, user, loggingIn, loading }) => {
      if (loggingIn) {
        return <LoadingIndicator />;
      }
      if (!userId) {
        return (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: props.location },
            }}
          />
        );
      }
      if (loading || !user) {
        return <LoadingIndicator />;
      }
      return <Route {...props} />;
    }}
  </UserConsumer>
);

export default PrivateRoute;
